import { get } from 'lodash'
import { ACTIVITY_CATEGORIES, CONFIGURATION_KEYS } from '../../constants/enums'


export const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const defaultResponse = { body: { value: false } }

  const email = get(values, 'assessorEmail')

  const authOrgId = get(props, 'authOrgId')

  const assignToOrganizationId = get(props, 'values.assignToOrganizationId')

  const orgId = (assignToOrganizationId ?? authOrgId) || get(props, 'activeOrganization.id')

  const activityCategoryId = get(values, 'activityCategory.id')

  const setupAssessorId = get(values, 'setupAssessorId')

  const isAssessorManagementEnabled = get(props, `configuration.valuesByOrganizationId.${orgId}.${CONFIGURATION_KEYS.manageAssessors.id}.booleanValue`)

    if (!isAssessorManagementEnabled || (isAssessorManagementEnabled && setupAssessorId > 0) || activityCategoryId === ACTIVITY_CATEGORIES.other.id) {
        return Promise.resolve()
    }

    if (!(email && orgId && activityCategoryId)) {
        return Promise.resolve()
    }

    const promises = Promise.all([
      props.checkAssessorEmailAvailability(email, orgId, activityCategoryId).catch(() => defaultResponse),
  ])
  const EMAIL_IN_USE = {
    text: 'E-mail address is already in use.',
    intlKey: 'errors.email_address_is_in_use'
  }

  return promises
      .then(r => {
          const body = r && get(r[0], 'body')

          if (!get(body, 'available')) {
              const errors = {
                  assessorEmail: EMAIL_IN_USE
              }

              throw errors
          }
      })
}

